// This icon file is generated automatically.
var PRedoOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M10.85 12.11a6.24 6.24 0 10-7.8-.08c.06.05.14.04.18-.02l.62-.79a.13.13 0 00-.02-.17A4.86 4.86 0 012.4 9.13a4.92 4.92 0 010-3.89 4.98 4.98 0 016.56-2.66 4.98 4.98 0 012.66 6.55 4.98 4.98 0 01-1.53 2l-.64-.82a.13.13 0 00-.22.05l-.62 2.53c-.02.08.04.16.12.16l2.61.01c.1 0 .17-.12.1-.2l-.58-.75z", "fill-rule": "nonzero" } }] }, "name": "p-redo", "theme": "outlined" };
export default PRedoOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PRedoOutlined.js
// module id = 3591
// module chunks = 0